module.exports = __webpack_public_path__ + "assets/img/202109-6W.b93e500d.png";